import type { TenantConfig } from "features/white-labeling/model/types";

let tenantConfig: null | TenantConfig = null;

export const setTenantConfig = (config: null | TenantConfig) => {
  tenantConfig = config;
};

export const getTenantConfig = (): null | TenantConfig => tenantConfig;
